// Dates as people say them.

const time = (d) => d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

function sameDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

// when is a day and a time: "Today, 2:30 PM", "Tomorrow, 9:00 AM", "Mon 12 Oct, 4:00 PM".
export function when(value) {
  if (!value) return "";
  const d = new Date(value);
  const now = new Date();
  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (sameDay(d, now)) return `Today, ${time(d)}`;
  if (sameDay(d, tomorrow)) return `Tomorrow, ${time(d)}`;
  if (sameDay(d, yesterday)) return `Yesterday, ${time(d)}`;
  const opts = { weekday: "short", day: "numeric", month: "short" };
  if (d.getFullYear() !== now.getFullYear()) opts.year = "numeric";
  return `${d.toLocaleDateString([], opts)}, ${time(d)}`;
}

// ago is how long ago, roughly: "just now", "5 min ago", "3 days ago".
export function ago(value) {
  if (!value) return "";
  const s = Math.round((Date.now() - new Date(value).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)} h ago`;
  if (s < 86400 * 7) return `${Math.floor(s / 86400)} days ago`;
  return when(value).split(",")[0];
}

// until is how long until, roughly: "in 12 min", "in 3 h".
export function until(value) {
  const s = Math.round((new Date(value).getTime() - Date.now()) / 1000);
  if (s <= 0) return "now";
  if (s < 3600) return `in ${Math.max(1, Math.round(s / 60))} min`;
  if (s < 86400) return `in ${Math.round(s / 3600)} h`;
  return `in ${Math.round(s / 86400)} days`;
}

// clock is a running duration: "4:05", "1:02:09".
export function clock(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  const pad = (n) => String(n).padStart(2, "0");
  return h ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
}

// greeting fits the hour.
export function greeting() {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 17) return "Good afternoon";
  return "Good evening";
}
